// IMPORTING THE ANGULAR MODULES FOR POPUPS.
import { NgModule } from "@angular/core";

// IMPORTING THE ANGULAR MODULES FOR DOING OPERATIONS ON URL.
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { PublicLayoutComponent } from "./layouts/public-layout/public-layout.component";
import { PageNotFoundComponent } from "./modules/page-not-found/page-not-found.component";

// HOLDS THE AUTHENTICATION GUARD.
import { UnauthorizedComponent } from "./modules/unauthorized/unauthorized.component";
import { AuthGuard } from "./services/auth.guard";

// DEFINING THE ROUTES FOR ANGULAR.
export const routes: Routes = [
	{
		path: "login",
		loadChildren: () =>
			import("./modules/login/login.module").then ((m) => m.loginModule),
	},
	{
		path: "reset-password",
		loadChildren: () =>
			import("./modules/forgot-password/forgot-password.module").then ((m) => m.ForgotPasswordModule),
	},


	{
		path: "otp-verification",
		loadChildren: () =>
			import("./modules/otp-verification/otp-verification.module").then ((m) => m.OtpVerficationModule),
	},

	{
		path: "",
		component: PublicLayoutComponent,
		canActivate: [AuthGuard],
		children:
		[
			{
				path: '', // EMPTY PATH
				redirectTo: 'dashboard', // REDIRECT TO THE "DASHBOARD" ROUTE
				pathMatch: 'full', // ENSURE A FULL MATCH TO THE EMPTY PATH
			},
			{
				path: "dashboard",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/dashboard/dashboard.module").then ((m) => m.DashboardModule),
			},
			{
				path: "users",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/manageusers/manageusers.module").then ((m) => m.ManageusersModule),
			},
			{
				path: "unauthorized",
				component: UnauthorizedComponent
			},
			{
				path: "auditlog/:loanapplication_id",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/auditlog/auditlog.module").then ((m) => m.AuditLogModule),
			},
			{
				path: "auditlog",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/auditlog/auditlog.module").then ((m) => m.AuditLogModule),
			},
			{
				path: "downlinemembers",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/downlinemembers/downlinemembers.module").then ((m) => m.DownlinemembersModule),
			},
			{
				path: "commission-report",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/commission-report/commission-report.module").then ((m) => m.CommissionReportModule),
			},
			{
				path: "referral-links",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/referral-links/referral-links.module").then ((m) => m.ReferralLinksModule),
			},
			{
				path: "settings",
				loadChildren: () =>
					import("./modules/setting/setting.module").then ((m) => m.SettingModule),
			},
			{
				path: "loan-application/:loanapplication_id",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/loanapplication/loanapplication.module").then ((m) => m.LoanapplicationModule),
			},
			{
				path: "loan-application/:loanapplication_id/:step_number",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/loanapplication/loanapplication.module").then ((m) => m.LoanapplicationModule),
			},
			{
				path: "loan-application",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/loanapplication/loanapplication.module").then ((m) => m.LoanapplicationModule),
			},
			{
				path: "submitted-applications",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/submitted-applications/submitted-applications.module").then ((m) => m.SubmittedApplicationsModule),
			},
			{
				path: "review-application/:preapprovalapplication_id",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/review-application/review-application.module").then ((m) => m.ReviewApplicationModule),
			},
			{
				path: "review-preapproval-request/:preapprovalrequest_id",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/review-preapproval-request/review-preapproval-request.module").then ((m) => m.ReviewPreapprovalRequestModule),
			},
			{
				path: "training-videos",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/training-videos/training-videos.module").then ((m) => m.TrainingVideosModule),
			},
			{
				path: "training-admin",
				canActivate: [AuthGuard],
				loadChildren: () =>
					import("./modules/training-admin/training-admin.module").then ((m) => m.TrainingAdminModule),
			},
			{ path: "**", component: PageNotFoundComponent },
		],
	},

];

// AN ANGULAR DECORATOR THAT IDENTIFIES THE MODULE'S OWN COMPONENTS, DIRECTIVES, AND PIPES.
// SO THAT EXTERNAL COMPONENTS CAN USE THEM.
@NgModule ({
	imports: [
		// SETTING THE ABOVE ROUTES IN ANGULAR ROUTER MODULE.
		RouterModule.forRoot (routes, { preloadingStrategy: PreloadAllModules }),
	],

	exports: [
		// EXPORTING THE ROUTER MODULE.
		RouterModule,
	],
})

// DECLARING THE AppRoutingModule CLASS WITH EXPORT SO THAT WE CAN IMPORT THIS SERVICE INTO ANY OTHER COMPONENT OR SERVICE.
export class AppRoutingModule {}
